import request from '../utils/request';
import { DashboardPeriod } from '@Types/dashboard';

const inFlightDashboardWidgetRequests = new Map<string, Promise<any>>();

function buildDashboardWidgetRequestKey(
  widget: string,
  services: string[],
  dataPeriod?: DashboardPeriod
) {
  const normalizedServices = [...services].sort().join(',');
  return `${widget}|${normalizedServices}|${dataPeriod || ''}`;
}

function getDashboardWidget(
  widget: string,
  services: string[],
  dataPeriod?: DashboardPeriod
) {
  const url = `/dashboard/${widget}?services=${encodeURIComponent(
    services.join(',')
  )}${dataPeriod ? `&dataPeriod=${dataPeriod}` : ''}`;

  const requestKey = buildDashboardWidgetRequestKey(
    widget,
    services,
    dataPeriod
  );
  const existingInFlight = inFlightDashboardWidgetRequests.get(requestKey);
  if (existingInFlight) {
    return existingInFlight;
  }

  const requestPromise = request({
    url,
    method: 'get',
  });

  inFlightDashboardWidgetRequests.set(requestKey, requestPromise);
  return requestPromise.finally(() => {
    inFlightDashboardWidgetRequests.delete(requestKey);
  });
}

function downloadDashboardReport(params: any) {
  return request({
    url: `/report/dashboard/generate`,
    method: 'post',
    //responseType: 'blob',
    //maxContentLength: Infinity,
    //maxBodyLength: Infinity,
    //timeout: 120000,
    data: params,
  });
}

function downloadCCBlockList() {
  return request({
    url: `blockLists`,
    method: 'get',
    timeout: 120000,
  });
}

export default {
  getDashboardWidget,
  downloadDashboardReport,
  downloadCCBlockList,
};
